import { AbstractControl, ValidationErrors } from '@angular/forms';
import { format } from 'date-fns-tz';
import { set } from 'date-fns';

export function sellerBrnValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;
  const maxLength = 20;
  const regex = /^[a-zA-Z0-9]*$/;

  if (value && value.length > maxLength) {
    return { maxLength: true };
  }

  if (value && !regex.test(value)) {
    return { invalidCharacters: true };
  }

  return null;
}

export function receiptNumberValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;
  const maxLength = 50;
  if (value && value.length > maxLength) {
    return { maxLength: true };
  }

  return null;
}

export function receiptTotalValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;

  const receiptTotalRegex = /^-?(\d{1,26}(\.\d{1,4})?)$/;

  if (!value) {
    return { required: true };
  }

  if (value && !receiptTotalRegex.test(value)) {
    return { invalidReceiptTotal: true };
  }

  return null;
}

export function receiptDateValidator(
  control: AbstractControl
): ValidationErrors | null {
  const inputDate = control.value;
  if (!inputDate) {
    return null;
  }
  const value = convertToMalaysiaDateFormat(inputDate);
  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const currentMonth = currentDate.getMonth(); // 0-based (January is 0)
  const currentYear = currentDate.getFullYear();

  // if (value === null) {
  //   return { required: true };
  // }

  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (value && !regex.test(value)) {
    return { invalidFormat: true };
  }

  const selectedDate = new Date(value);
  if (isNaN(selectedDate.getTime())) {
    return { invalidDate: true }; // Invalid date
  }

  const selectedYear = selectedDate.getFullYear();
  const selectedMonth = selectedDate.getMonth(); // 0-based (January is 0)
  const selectedDay = selectedDate.getDate();

  if (currentDay > 3) {
    if (selectedYear !== currentYear || selectedMonth !== currentMonth) {
      return { invalidMonth: true };
    }
    if (selectedDate > currentDate) {
      return { futureDate: true };
    }
  } else {
    const previousMonthDate = new Date(currentYear, currentMonth - 1, 1);
    if (selectedDate > currentDate || selectedDate < previousMonthDate) {
      return { invalidMonth: true };
    }
  }

  return null;
}

export function sstRegistrationNumberValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value ? control.value.trim() : '';

  const maxLength = 35;
  const regex = /^[a-zA-Z0-9-]*$/; // Only allows letters, numbers, and dashes

  // If the length is exactly 35, check for the semicolon condition
  if (value.length === maxLength) {
    const semicolonPosition = value.indexOf(';');

    // Check if semicolon exists and if it's in the correct position (18th position, 0-indexed)
    if (semicolonPosition !== -1 && semicolonPosition !== 17) {
      return { invalidCharacters: true };
    }
  }

  // Check if the value contains only allowed characters (letters, numbers, dash, and optionally semicolon)
  if (
    !regex.test(value) &&
    !(value.indexOf(';') === 17 && value.length === maxLength)
  ) {
    return { invalidCharacters: true };
  }

  // If no errors, return null
  return null;
}

function convertToMalaysiaDateFormat(date: Date): string {
  const malaysiaTimeZone = 'Asia/Kuala_Lumpur'; // Malaysia timezone (UTC +8)
  const formattedDate = format(date, 'yyyy-MM-dd', {
    timeZone: malaysiaTimeZone,
  });
  return formattedDate;
}
